export default function downloadCourse(course, userID, serverOrigin) {
	let {apiName, fileName} = course;
	let body = JSON.stringify({
		userID: userID,
		courseName: apiName,
		fileName: fileName,
	});

	fetch(`${serverOrigin}/courses/getDownloadToken`, {
		method: 'post',
		credentials: 'include',
		headers: {'Content-Type': 'application/json'},
		body: body,
	})
		.then(res => {
			return res.json();
		})
		.then(res => {
			let token = res.token;
			window.location.href = `${serverOrigin}/courses/download?token=${token}&fileName=${fileName}`;
		})
		.catch(err => {
			console.error(err.message);
		});
}
